/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class DownloadsApi extends BaseApi {
    cancelDownload(downloadId) {
        throwIfNotDefined(downloadId, 'downloadId');
        const pathParams = {
            downloadId
        };
        return this.delete({
            path: '/downloads/{downloadId}',
            pathParams
        });
    }
    createDownload(downloadBodyCreate, opts) {
        throwIfNotDefined(downloadBodyCreate, 'downloadBodyCreate');
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/downloads',
            queryParams,
            bodyParam: downloadBodyCreate
        });
    }
    getDownload(downloadId, opts) {
        throwIfNotDefined(downloadId, 'downloadId');
        const pathParams = {
            downloadId
        };
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/downloads/{downloadId}',
            pathParams,
            queryParams
        });
    }
}
